import { ReactNode } from 'react';
import styled from '@emotion/styled';

type P = {
  title: string;
  onClick: () => void;
  rightIcon?: ReactNode;
  active: boolean;
  count?: number;
};

const DocumentFilterButton = ({
  title,
  onClick,
  rightIcon,
  active,
  count,
}: P) => {
  return (
    <StyledButton type={'button'} onClick={onClick} active={active}>
      <div>
        {title}
        <span
          style={{
            marginLeft: '8px',
            fontWeight: '500',
          }}
        >
          {count}
        </span>
      </div>
      {rightIcon}
    </StyledButton>
  );
};

export default DocumentFilterButton;

const StyledButton = styled.button<{ active: boolean }>`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  font-style: normal;
  //font-weight: 500;
  line-height: 24px; /* 150% */
  color: ${({ active }) => (active ? 'var(--dk-accent, #06c)' : 'var(--dk-text, black)')};
  background-color: ${({ active }) => (active ? 'rgba(0,102,204,0.10)' : '')};
  width: 100%;
  justify-content: space-between;
`;
